<template>
<!-- ▼▼▼ 一般 ▼▼▼ -->
<div class="step step--type-2">
<div class="step__main">
<h2 class="heading-step">
<span class="heading-step__step">STEP<em>2</em> </span>
<span class="heading-step__title">
<span class="heading-step__text">ねんきん定期便情報の入力</span>
<span>
<router-link tag="a" class="heading-step__anchor" to="image-view-nenkin-teikibin" data-window-width="787" data-window-height="633" data-window-name="nenkin-teikibin" @click.native="openWindow" v-if="value1 === 35 || value1 === 45"><span>入力箇所がわからない方はこちら <img src="../assets/img/icon-heading-step.png" alt="?"></span></router-link>
<router-link tag="a" class="heading-step__anchor" to="image-view-nenkin-teikibin" data-window-width="787" data-window-height="643" data-window-name="nenkin-teikibin" @click.native="openWindow" v-else-if="value1 === 59"><span>入力箇所がわからない方はこちら <img src="../assets/img/icon-heading-step.png" alt="?"></span></router-link>
<router-link tag="a" class="heading-step__anchor" to="image-view-nenkin-teikibin" data-window-width="704" data-window-height="801" data-window-name="nenkin-teikibin" @click.native="openWindow" v-else-if="value1 < 50"><span>入力箇所がわからない方はこちら <img src="../assets/img/icon-heading-step.png" alt="?"></span></router-link>
<router-link tag="a" class="heading-step__anchor" to="image-view-nenkin-teikibin" data-window-width="704" data-window-height="801" data-window-name="nenkin-teikibin" @click.native="openWindow" v-else><span>入力箇所がわからない方はこちら <img src="../assets/img/icon-heading-step.png" alt="?"></span></router-link>
<a class="heading-step__anchor" href="#" @click="openModalStep2Help"><span>ねんきん定期便がお手元にない方はこちら <img src="../assets/img/icon-heading-step-02.png" alt="?"></span></a>
</span>
</span>
<!-- /.heading-step --></h2>

<modal-step2-help :isShow="isShowModalStep2Help" @close="closeModalStep2Help" @submit="submitModalStep2Help"></modal-step2-help>

<div class="box-alert" v-show="value8_error || value9_error || value10_1_error || value10_2_error || value10_3_error || value11_1_error || value11_2_error">
<ul class="list-alert">
<li class="list-alert__item" v-show="value8_error"><strong>「A. 厚生年金保険　計」が未入力です。</strong></li>
<li class="list-alert__item" v-show="value9_error"><strong>「C. 国民年金　老齢基礎年金」が未入力です。</strong></li>
<li class="list-alert__item" v-show="value10_1_error"><strong>「D. 厚生年金保険　老齢厚生年金／一般厚生年金」が未入力です。</strong></li>
<li class="list-alert__item" v-show="value10_2_error"><strong>「D. 厚生年金保険　老齢厚生年金／公務員厚生年金（国家公務員・地方公務員）」が未入力です。</strong></li>
<li class="list-alert__item" v-show="value10_3_error"><strong>「D. 厚生年金保険　老齢厚生年金／私学共済厚生年金（私立学校の教職員）」が未入力です。</strong></li>
<li class="list-alert__item" v-show="value11_1_error"><strong>「C. 国民年金　老齢基礎年金」が未入力です。</strong></li>
<li class="list-alert__item" v-show="value11_2_error && 50 <= value1 && value1 < 59"><strong>「D. （1）と（2）の合計」が未入力です。</strong></li>
<li class="list-alert__item" v-show="value11_2_error && 59 <= value1"><strong>「D. 1年間の受取見込額」が未入力です。</strong></li>
<!-- /.list-alert --></ul>
<!-- /.box-alert --></div>

<div class="column column--col-3">
<div class="column__inner">
<div class="column__col" v-show="!(value3 === '自営業' || value3 === '専業主婦・専業主夫')">
<h3 class="heading-02" v-show="!(value3 === '自営業' || (value3 === '専業主婦・専業主夫' && value4 === '国保の加入者'))">これまでの年金加入期間</h3>

<h4 class="heading-label"><label for="label-dummy-plan-price-01">A. 厚生年金保険　計</label></h4>

<div class="form-text">
<input type="text" name="name-dummy-plan-price-01" id="label-dummy-plan-price-01" :class="['form-text__input', { 'is-error': value8_error }]" placeholder="月数を入力" v-model="value8" @change="changeValue8ByEvent" @blur="changeValue8ByEvent"><span class="form-text__unit">月</span>
<!-- /.form-text --></div>
<!-- /.column__col --></div>

<div class="column__col column__col--col-2" v-show="!(value3 === '自営業' || (value3 === '専業主婦・専業主夫' && value4 === '国保の加入者'))">
<h3 class="heading-02"><strong class="text-strong" v-show="value3 === '専業主婦・専業主夫' && value4 === '健康保険の被扶養者' && value5 === 1">配偶者の</strong>標準報酬月額</h3>

<h4 class="heading-label"><label for="label-dummy-plan-price-02">B. 直近の金額</label></h4>

<div class="form-select">
<select name="name-dummy-plan-price-02" id="label-dummy-plan-price-02" class="form-select__select" v-model="value12_1" @change="changeValue12_1ByEvent">
<option value="">選択ください</option>
<option value="88000">88千円</option>
<option value="98000">98千円</option>
<option value="104000">104千円</option>
<option value="110000">110千円</option>
<option value="118000">118千円</option>
<option value="126000">126千円</option>
<option value="134000">134千円</option>
<option value="142000">142千円</option>
<option value="150000">150千円</option>
<option value="160000">160千円</option>
<option value="170000">170千円</option>
<option value="180000">180千円</option>
<option value="190000">190千円</option>
<option value="200000">200千円</option>
<option value="220000">220千円</option>
<option value="240000">240千円</option>
<option value="260000">260千円</option>
<option value="280000">280千円</option>
<option value="300000">300千円</option>
<option value="320000">320千円</option>
<option value="340000">340千円</option>
<option value="360000">360千円</option>
<option value="380000">380千円</option>
<option value="410000">410千円</option>
<option value="440000">440千円</option>
<option value="470000">470千円</option>
<option value="500000">500千円</option>
<option value="530000">530千円</option>
<option value="560000">560千円</option>
<option value="590000">590千円</option>
<option value="620000">620千円</option>
<!-- /.form-select__select --></select>
<!-- /.form-select --></div>

<ul class="list-notice" v-show="value3 === '専業主婦・専業主夫' && value4 === '健康保険の被扶養者'">
<li class="list-notice__item"><small><span class="list-notice__item-mark">※ </span>金額の選択がない場合、一部試算できない項目があります。</small></li>
<!-- /.list-notice --></ul>
<!-- /.column__col --></div>
<!-- /.column__inner --></div>
<!-- /.column --></div>



<!-- ▼▼▼ 50歳未満の場合 ▼▼▼ -->
<div v-show="value1 < 50">
<h3 class="heading-02">これまでの加入実績に応じた年金額（年額）</h3>

<div class="column column--col-3">
<div class="column__inner">
<div class="column__col">
<h3 class="heading-label"><label for="label-dummy-plan-price-agency-03">C. 国民年金　老齢基礎年金</label></h3>

<div class="form-text">
<input type="text" name="name-dummy-plan-price-agency-03" id="label-dummy-plan-price-agency-03" :class="['form-text__input', { 'is-error': value9_error }]" placeholder="金額を入力" v-model="value9" @change="changeValue9ByEvent" @blur="changeValue9ByEvent"><span class="form-text__unit">円</span>
<!-- /.form-text --></div>
<!-- /.column__col --></div>

<div class="column__col column__col--col-2">
<h3 class="heading-label">D. 厚生年金保険　老齢厚生年金</h3>

<div class="form-text-02">
<label class="form-text-02__label">
<b class="form-text-02__label-text">一般厚生年金</b>
<span class="form-text-02__label-form">
<input type="text" name="name-dummy-time-nenkin-01" :class="['form-text-02__label-input', { 'is-error': value10_1_error }]" placeholder="金額を入力" v-model="value10_1" @change="changeValue10_1ByEvent" @blur="changeValue10_1ByEvent"><span class="form-text-02__label-unit">円</span>
<!-- /.form-text-02__label-form --></span>
<!-- /.form-text-02__label --></label>
<!-- /.form-text-02 --></div>

<div class="form-text-02">
<label class="form-text-02__label">
<b class="form-text-02__label-text">公務員厚生年金<br>（国家公務員・地方公務員）</b>
<span class="form-text-02__label-form">
<input type="text" name="name-dummy-time-nenkin-02" :class="['form-text-02__label-input', { 'is-error': value10_2_error }]" placeholder="金額を入力" v-model="value10_2" @change="changeValue10_2ByEvent" @blur="changeValue10_2ByEvent"><span class="form-text-02__label-unit">円</span>
<!-- /.form-text-02__label-form --></span>
<!-- /.form-text-02__label --></label>
<!-- /.form-text-02 --></div>

<div class="form-text-02">
<label class="form-text-02__label">
<b class="form-text-02__label-text">私学共済厚生年金<br>（私立学校の教職員）</b>
<span class="form-text-02__label-form">
<input type="text" name="name-dummy-time-nenkin-03" :class="['form-text-02__label-input', { 'is-error': value10_3_error }]" placeholder="金額を入力" v-model="value10_3" @change="changeValue10_3ByEvent" @blur="changeValue10_3ByEvent"><span class="form-text-02__label-unit">円</span>
<!-- /.form-text-02__label-form --></span>
<!-- /.form-text-02__label --></label>
<!-- /.form-text-02 --></div>
<!-- /.column__col --></div>
<!-- /.column__inner --></div>
<!-- /.column --></div>
</div>
<!-- ▲▲▲ 50歳未満の場合 ▲▲▲ -->

<!-- ▼▼▼ 50歳以上59歳未満の場合 ▼▼▼ -->
<div v-show="50 <= value1 && value1 < 59">
<h3 class="heading-02">老齢年金の種類と見込額（1年間の受取見込額）</h3>

<div class="column column--col-3">
<div class="column__inner">
<div class="column__col">
<h3 class="heading-label"><label for="label-dummy-plan-price-04">C. 国民年金　老齢基礎年金</label></h3>

<div class="form-text">
<input type="text" name="name-dummy-plan-price-04" id="label-dummy-plan-price-04" :class="['form-text__input', { 'is-error': value11_1_error }]" placeholder="金額を入力" v-model="value11_1" @change="changeValue11_1ByEvent" @blur="changeValue11_1ByEvent"><span class="form-text__unit">円</span>
<!-- /.form-text --></div>
<!-- /.column__col --></div>

<div class="column__col column__col--col-2">
<h3 class="heading-label">
<router-link tag="a" class="heading-label__link" to="image-view-nenkin-teikibin" data-window-width="787" data-window-height="633" data-window-name="nenkin-teikibin" @click.native="openWindow" v-if="value1 === 35 || value1 === 45"><span class="heading-label__link-inner">D. （1）と（2）の合計 <img src="../assets/img/icon-heading-label.png" alt="?"></span></router-link>
<router-link tag="a" class="heading-label__link" to="image-view-nenkin-teikibin" data-window-width="787" data-window-height="643" data-window-name="nenkin-teikibin" @click.native="openWindow" v-else-if="value1 === 59"><span class="heading-label__link-inner">D. （1）と（2）の合計 <img src="../assets/img/icon-heading-label.png" alt="?"></span></router-link>
<router-link tag="a" class="heading-label__link" to="image-view-nenkin-teikibin" data-window-width="704" data-window-height="801" data-window-name="nenkin-teikibin" @click.native="openWindow" v-else-if="value1 < 50"><span class="heading-label__link-inner">D. （1）と（2）の合計 <img src="../assets/img/icon-heading-label.png" alt="?"></span></router-link>
<router-link tag="a" class="heading-label__link" to="image-view-nenkin-teikibin" data-window-width="704" data-window-height="801" data-window-name="nenkin-teikibin" @click.native="openWindow" v-else><span class="heading-label__link-inner">D. （1）と（2）の合計 <img src="../assets/img/icon-heading-label.png" alt="?"></span></router-link>
</h3>

<div class="form-text">
<input type="text" name="name-dummy-plan-price-05" id="label-dummy-plan-price-05" :class="['form-text__input', { 'is-error': value11_2_error }]" placeholder="金額を入力" v-model="value11_2" @change="changeValue11_2ByEvent" @blur="changeValue11_2ByEvent"><span class="form-text__unit">円</span>
<!-- /.form-text --></div>
<p>「（1）と（2）の合計」は、ねんきん定期便の「２．老齢年金の種類と見込額（１年間の受取見込額）」の最下段に表示されています。<br>ご不明な方は<img src="../assets/img/icon-heading-label.png" alt="?">マークをご確認ください。</p>
<!-- /.column__col --></div>
<!-- /.column__inner --></div>
<!-- /.column --></div>
</div>
<!-- ▲▲▲ 50歳以上59歳未満の場合 ▲▲▲ -->

<!-- ▼▼▼ 59歳の場合 ▼▼▼ -->
<div v-show="59 <= value1">
<h3 class="heading-02">老齢年金の見込額</h3>

<div class="column column--col-3">
<div class="column__inner">
<div class="column__col">
<h3 class="heading-label"><label for="label-dummy-plan-price-06">C. 国民年金　老齢基礎年金</label></h3>

<div class="form-text">
<input type="text" name="name-dummy-plan-price-06" id="label-dummy-plan-price-06" :class="['form-text__input', { 'is-error': value11_1_error }]" placeholder="金額を入力" v-model="value11_1" @change="changeValue11_1ByEvent" @blur="changeValue11_1ByEvent"><span class="form-text__unit">円</span>
<!-- /.form-text --></div>
<!-- /.column__col --></div>

<div class="column__col column__col--col-2">
<h3 class="heading-label">
<router-link tag="a" class="heading-label__link" to="image-view-nenkin-teikibin" data-window-width="787" data-window-height="633" data-window-name="nenkin-teikibin" @click.native="openWindow" v-if="value1 === 35 || value1 === 45"><span class="heading-label__link-inner">D. 1年間の受取見込額 <img src="../assets/img/icon-heading-label.png" alt="?"></span></router-link>
<router-link tag="a" class="heading-label__link" to="image-view-nenkin-teikibin" data-window-width="787" data-window-height="643" data-window-name="nenkin-teikibin" @click.native="openWindow" v-else-if="value1 === 59"><span class="heading-label__link-inner">D. 1年間の受取見込額 <img src="../assets/img/icon-heading-label.png" alt="?"></span></router-link>
<router-link tag="a" class="heading-label__link" to="image-view-nenkin-teikibin" data-window-width="704" data-window-height="801" data-window-name="nenkin-teikibin" @click.native="openWindow" v-else-if="value1 < 50"><span class="heading-label__link-inner">D. 1年間の受取見込額 <img src="../assets/img/icon-heading-label.png" alt="?"></span></router-link>
<router-link tag="a" class="heading-label__link" to="image-view-nenkin-teikibin" data-window-width="704" data-window-height="801" data-window-name="nenkin-teikibin" @click.native="openWindow" v-else><span class="heading-label__link-inner">D. 1年間の受取見込額 <img src="../assets/img/icon-heading-label.png" alt="?"></span></router-link>
</h3>

<div class="form-text">
<input type="text" name="name-dummy-plan-price-07" id="label-dummy-plan-price-07" :class="['form-text__input', { 'is-error': value11_2_error }]" placeholder="金額を入力" v-model="value11_2" @change="changeValue11_2ByEvent" @blur="changeValue11_2ByEvent"><span class="form-text__unit">円</span>
<!-- /.form-text --></div>
<p>「1年間の受取見込額」は、ねんきん定期便の「２．老齢年金の見込額」の最下段に表示されています。ご不明な方は<img src="../assets/img/icon-heading-label.png" alt="?">マークをご確認ください。</p>
<!-- /.column__col --></div>
<!-- /.column__inner --></div>
<!-- /.column --></div>
</div>
<!-- ▲▲▲ 59歳の場合 ▲▲▲ -->
<!-- /.step__main --></div>

<div class="step__foot">
<div class="step__foot-button">
<div class="button-submit">
<router-link tag="button" type="button" class="button-submit__button" to="step3" v-if="validateStep2">
<span class="button-submit__button-inner">STEP3へ</span>
<!-- /.button-submit__button --></router-link>
<router-link tag="button" type="button" class="button-submit__button" to="step4" v-else-if="validateStep2SkipStep3">
<span class="button-submit__button-inner">試算する</span>
<!-- /.button-submit__button --></router-link>
<router-link tag="button" type="button" class="button-submit__button" to="step3" v-else disabled>
<span class="button-submit__button-inner">STEP3へ</span>
<!-- /.button-submit__button --></router-link>
<!-- /.button-submit --></div>

<div class="button-back">
<router-link tag="button" type="button" class="button-back__button" to="step1">
<span class="button-back__button-inner">STEP1に戻る</span>
<!-- /.button-back__button --></router-link>
<!-- /.button-back --></div>
<!-- /.step-foot-button --></div>
<!-- /.step__foot --></div>
<!-- /.step --></div>
<!-- ▲▲▲ 一般 ▲▲▲ -->
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    import ModalStep2Help from '@/components/ModalStep2Help';
    import Utils from '../assets/js/Utils';

    export default {
        components: {
            ModalStep2Help
        },
        computed: {
            ...mapGetters([
                'agencyCode',
                'agentCode',
                'agencyMode',
                'step2HelpMode',
                'value1',
                'value2',
                'value3',
                'value4',
                'value5',
                'value8_text',
                'value9_text',
                'value10_1_text',
                'value10_2_text',
                'value10_3_text',
                'value11_1_text',
                'value11_2_text',
                'value12_1_text',
                'validateStep1',
                'validateStep2',
                'validateStep2SkipStep3',
                'validateStep2Help'
            ]),
            value8: {
                get() {
                    return this.$store.getters.value8;
                },
                set(value) {
                    this.changeValue8(value);
                }
            },
            value9: {
                get() {
                    return Utils.addComma(this.$store.getters.value9);
                },
                set(value) {
                    this.changeValue9(value);
                }
            },
            value10_1: {
                get() {
                    return Utils.addComma(this.$store.getters.value10_1);
                },
                set(value) {
                    this.changeValue10_1(value);
                }
            },
            value10_2: {
                get() {
                    return Utils.addComma(this.$store.getters.value10_2);
                },
                set(value) {
                    this.changeValue10_2(value);
                }
            },
            value10_3: {
                get() {
                    return Utils.addComma(this.$store.getters.value10_3);
                },
                set(value) {
                    this.changeValue10_3(value);
                }
            },
            value11_1: {
                get() {
                    return Utils.addComma(this.$store.getters.value11_1);
                },
                set(value) {
                    this.changeValue11_1(value);
                }
            },
            value11_2: {
                get() {
                    return Utils.addComma(this.$store.getters.value11_2);
                },
                set(value) {
                    this.changeValue11_2(value);
                }
            },
            value12_1: {
                get() {
                    return this.$store.getters.value12_1;
                },
                set(value) {
                    this.changeValue12_1(value);
                    this.changeValue12_2(value);
                    this.changeValue12_3(value);
                    this.changeValue12_4(value);
                    this.changeValue12_5(value);
                    this.changeValue12_6(value);
                    this.changeValue12_7(value);
                    this.changeValue12_8(value);
                    this.changeValue12_9(value);
                    this.changeValue12_10(value);
                    this.changeValue12_11(value);
                    this.changeValue12_12(value);
                }
            }
        },
        data() {
            return {
                value8_error: false,
                value9_error: false,
                value10_1_error: false,
                value10_2_error: false,
                value10_3_error: false,
                value11_1_error: false,
                value11_2_error: false,
                isShowModalStep2Help: false
            };
        },
        methods: {
            ...mapActions([
                'changeStep2HelpMode',
                'changeValue8',
                'changeValue8Text',
                'changeValue9',
                'changeValue9Text',
                'changeValue10_1',
                'changeValue10_1Text',
                'changeValue10_2',
                'changeValue10_2Text',
                'changeValue10_3',
                'changeValue10_3Text',
                'changeValue11_1',
                'changeValue11_1Text',
                'changeValue11_2',
                'changeValue11_2Text',
                'changeValue12_1',
                'changeValue12_1Text',
                'changeValue12_2',
                'changeValue12_3',
                'changeValue12_4',
                'changeValue12_5',
                'changeValue12_6',
                'changeValue12_7',
                'changeValue12_8',
                'changeValue12_9',
                'changeValue12_10',
                'changeValue12_11',
                'changeValue12_12'
            ]),
            changeValue8ByEvent(event) {
                const currentTarget = event.currentTarget;
                const value = currentTarget.value;
                const numberChecked = Utils.isNumberString(value);
                let numberString = '';

                this.value8_error = !numberChecked;
                this.changeValue8(value);

                numberString = String(this.$store.getters.value8);
                currentTarget.value = numberString;
                this.changeValue8Text(numberString);
            },
            changeValue9ByEvent(event) {
                const currentTarget = event.currentTarget;
                const value = currentTarget.value;
                const numberChecked = Utils.isNumberString(value);
                let numberStringWithComma = '';

                this.value9_error = !numberChecked;
                this.changeValue9(value);

                numberStringWithComma = Utils.addComma(this.$store.getters.value9);
                currentTarget.value = numberStringWithComma;
                this.changeValue9Text(numberStringWithComma);
            },
            changeValue10_1ByEvent(event) {
                const currentTarget = event.currentTarget;
                const value = currentTarget.value;
                const numberChecked = Utils.isNumberString(value);
                let numberStringWithComma = '';

                this.value10_1_error = !numberChecked;
                this.changeValue10_1(value);

                numberStringWithComma = Utils.addComma(this.$store.getters.value10_1);
                currentTarget.value = numberStringWithComma;
                this.changeValue10_1Text(numberStringWithComma);
            },
            changeValue10_2ByEvent(event) {
                const currentTarget = event.currentTarget;
                const value = currentTarget.value;
                const numberChecked = Utils.isNumberString(value);
                let numberStringWithComma = '';

                this.value10_2_error = !numberChecked;
                this.changeValue10_2(value);

                numberStringWithComma = Utils.addComma(this.$store.getters.value10_2);
                currentTarget.value = numberStringWithComma;
                this.changeValue10_2Text(numberStringWithComma);
            },
            changeValue10_3ByEvent(event) {
                const currentTarget = event.currentTarget;
                const value = currentTarget.value;
                const numberChecked = Utils.isNumberString(value);
                let numberStringWithComma = '';

                this.value10_3_error = !numberChecked;
                this.changeValue10_3(value);

                numberStringWithComma = Utils.addComma(this.$store.getters.value10_3);
                currentTarget.value = numberStringWithComma;
                this.changeValue10_3Text(numberStringWithComma);
            },
            changeValue11_1ByEvent(event) {
                const currentTarget = event.currentTarget;
                const value = currentTarget.value;
                const numberChecked = Utils.isNumberString(value);
                let numberStringWithComma = '';

                this.value11_1_error = !numberChecked;
                this.changeValue11_1(value);

                numberStringWithComma = Utils.addComma(this.$store.getters.value11_1);
                currentTarget.value = numberStringWithComma;
                this.changeValue11_1Text(numberStringWithComma);
            },
            changeValue11_2ByEvent(event) {
                const currentTarget = event.currentTarget;
                const value = currentTarget.value;
                const numberChecked = Utils.isNumberString(value);
                let numberStringWithComma = '';

                this.value11_2_error = !numberChecked;
                this.changeValue11_2(value);

                numberStringWithComma = Utils.addComma(this.$store.getters.value11_2);
                currentTarget.value = numberStringWithComma;
                this.changeValue11_2Text(numberStringWithComma);
            },
            changeValue12_1ByEvent(event) {
                const currentTarget = event.currentTarget;
                const textContent = Utils.extractOptionElementTextContentBySelectElement(currentTarget);

                this.changeValue12_1Text(textContent);
            },
            openWindow(event) {
                Utils.openWindow(event);
            },
            openModalStep2Help(e) {
                e.preventDefault();
                this.isShowModalStep2Help = true;
            },
            closeModalStep2Help() {
                this.isShowModalStep2Help = false;
            },
            submitModalStep2Help() {
                this.isShowModalStep2Help = false;
                this.changeStep2HelpMode(true); // ヘルプモードをtrueにする

                if (this.value3 === '専業主婦・専業主夫' && this.value4 === '健康保険の被扶養者') {
                    this.$router.push({
                        name: 'Step4'
                    });
                } else {
                    this.$router.push({
                        name: 'Step3'
                    });
                }
            }
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                const s = window.s;

                if (s) {
                    if (from.name !== null && to.name === 'Step2') {
                        // 他 STEP からの遷移時
                        let agencyVariableString;
                        let sCode;

                        if (vm.agencyMode) {
                            agencyVariableString = vm.agencyCode + '|' + vm.agentCode;
                        } else {
                            agencyVariableString = '|';
                        }

                        s.pageName = '【RWD】公的保障試算ツール(STEP2)';
                        s.prop11 = agencyVariableString;
                        s.eVar11 = agencyVariableString;
                        s.prop12 = '';
                        s.eVar12 = '';
                        s.prop13 = '';
                        s.eVar13 = '';
                        s.prop14 = '';
                        s.eVar14 = '';
                        s.prop15 = '';
                        s.eVar15 = '';
                        s.events = '';
                        s.linkTrackEvents = '';

                        sCode = s.t();

                        if (sCode) {
                            document.write(sCode);
                        }
                    }
                }
            });
        },
        mounted() {
            // STEP2になったらヘルプモードを一度falseに設定する
            this.changeStep2HelpMode(false);
        },
        beforeRouteLeave(to, from, next) {
            const sendTrackingCode = () => {
                const s = window.s;

                if (s) {
                    if (from.name === 'Step2' && to.name === 'Step3') {
                        const values = [
                            this.value8_text,
                            this.value9_text,
                            this.value10_1_text,
                            this.value10_2_text,
                            this.value10_3_text,
                            this.value11_1_text,
                            this.value11_2_text,
                            this.value12_1_text
                        ];
                        const joinedValues = values.join('|');

                        s.prop13 = joinedValues;
                        s.eVar13 = joinedValues;
                        s.linkTrackVars = 'prop13,eVar13,events';
                        s.events = 'event3';
                        s.linkTrackEvents = 'event3';
                        s.tl(window, 'o', '公的保障試算ツール STEP3へ');
                    } else if (from.name === 'Step2' && to.name === 'Step4') {
                        const values = [
                            this.value8_text,
                            this.value9_text,
                            this.value10_1_text,
                            this.value10_2_text,
                            this.value10_3_text,
                            this.value11_1_text,
                            this.value11_2_text,
                            this.value12_1_text
                        ];
                        const joinedValues = values.join('|');

                        s.prop13 = joinedValues;
                        s.eVar13 = joinedValues;
                        s.linkTrackVars = 'prop13,eVar13';
                        s.tl(window, 'o', '公的保障試算ツール 試算する');
                    } else if (from.name === 'Step2' && to.name === 'Step1') {
                        const values = [
                            this.value8_text,
                            this.value9_text,
                            this.value10_1_text,
                            this.value10_2_text,
                            this.value10_3_text,
                            this.value11_1_text,
                            this.value11_2_text,
                            this.value12_1_text
                        ];
                        const joinedValues = values.join('|');

                        s.prop13 = joinedValues;
                        s.eVar13 = joinedValues;
                        s.linkTrackVars = 'prop13,eVar13';
                        s.tl(window, 'o', '公的保障試算ツール STEP1に戻る');
                    }
                }
            };

            if (from.name === 'Step2' && to.name === 'Step3') {
                if (this.step2HelpMode) {
                    if (this.validateStep2Help) {
                        next();
                    } else {
                        next(false);
                    }
                } else {
                    if (this.validateStep2) {
                        sendTrackingCode();
                        next();
                    } else {
                        next(false);
                    }
                }
            } else if (from.name === 'Step2' && to.name === 'Step4') {
                if (this.step2HelpMode) {
                    if (this.validateStep2Help) {
                        next();
                    } else {
                        next(false);
                    }
                } else {
                    if (this.validateStep2SkipStep3) {
                        sendTrackingCode();
                        next();
                    } else {
                        next(false);
                    }
                }
            } else if (from.name === 'Step2' && to.name === 'Step1') {
                sendTrackingCode();
                next();
            } else {
                next(false);
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/Step2.vue